import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const AI_UNAVAILABLE_MESSAGE =
  "IA temporariamente indisponível. As demais operações continuam disponíveis.";

export function useAIAvailability(enabled = true) {
  const { user } = useAuth();
  const identity = `${user?.tenant_id || ""}:${user?.id || ""}`;
  const [state, setState] = useState({ identity: null, available: false, loading: true });
  useEffect(() => {
    let active = true;
    setState({ identity, available: false, loading: enabled });
    if (enabled) {
      api.get("/ai/status").then(({ data }) => {
        if (active) setState({ identity, available: data?.available === true, loading: false });
      }).catch(() => {
        if (active) setState({ identity, available: false, loading: false });
      });
    }
    return () => { active = false; };
  }, [enabled, identity]);
  const available = enabled && state.identity === identity && state.available;
  const loading = enabled && (state.identity !== identity || state.loading);
  return {
    available,
    loading,
    markUnavailable: () => setState({ identity, available: false, loading: false }),
    message: loading ? "Verificando disponibilidade da IA..." : AI_UNAVAILABLE_MESSAGE,
  };
}
